export default __webpack_public_path__ + "static/media/citlogo.f9b60ebe.svg";